module.exports = __webpack_public_path__ + "static/media/ucatapult.15cb069c.jpeg";